/**
 * Componente de gráfico de barras para Control Semanal
 */

import React from 'react';
import { Card } from 'react-bootstrap';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';
import * as FaIcons from 'react-icons/fa';
import { formatDate } from '../utils/helpers';
import { CHART_COLORS, STATE_LABELS } from '../utils/constants';

const WeeklyChart = ({ dateColumns, weeklyData, allStates }) => {
  // Si no hay datos, no mostrar el gráfico
  if (!allStates.length) {
    return null;
  }

  // Preparar datos para el gráfico
  const prepareChartData = () => {
    return dateColumns.map(date => {
      const dataPoint = {
        fecha: formatDate(date),
        fechaCompleta: date
      };

      allStates.forEach(state => {
        dataPoint[state] = weeklyData[date]?.[state] || 0;
      });

      return dataPoint;
    });
  };

  return (
    <Card className="mt-4">
      <Card.Header>
        <h5 className="mb-0">
          <FaIcons.FaChartBar className="me-2" />
          Distribución por Estado
        </h5>
      </Card.Header>
      <Card.Body>
        <ResponsiveContainer width="100%" height={400}>
          <BarChart
            data={prepareChartData()}
            margin={{
              top: 20,
              right: 30,
              left: 20,
              bottom: 5
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="fecha"
              tick={{ fontSize: 12 }}
              angle={-45}
              textAnchor="end"
              height={80}
            />
            <YAxis />
            <Tooltip
              formatter={(value, name) => [value, STATE_LABELS[name] || name]}
              labelFormatter={(label) => `Fecha: ${label}`}
            />
            <Legend
              formatter={(value) => STATE_LABELS[value] || value}
            />
            {allStates.map(state => (
              <Bar
                key={state}
                dataKey={state}
                fill={CHART_COLORS[state] || '#6c757d'}
                name={state}
              />
            ))}
          </BarChart>
        </ResponsiveContainer>
      </Card.Body>
    </Card>
  );
};

export default WeeklyChart;
